import { przezmorzeApi } from "../../../api/api";
import type { AdminCustomerNote, AdminCustomerNoteListResponse } from "@przezmorze/api-types";

export type { AdminCustomerNote };

export interface ListCustomerNotesAdminParams {
  readonly dateFrom: string;
  readonly dateTo: string;
  readonly accountManagerId?: string;
  readonly type?: string;
}

export async function listCustomerNotesAdmin(
  params: ListCustomerNotesAdminParams,
  signal?: AbortSignal,
): Promise<AdminCustomerNote[]> {
  const response = await przezmorzeApi.get<AdminCustomerNoteListResponse>("/customer-notes", {
    params,
    signal,
  });
  return response.data.items;
}
